// THIS FILE IS AUTO-GENERATED. DO NOT MODIFY IT.
// Please edit ./day.theme.ts instead, then run `yarn theme:build`
import { css } from '@linaria/core'

export default css`
  --gray00: #ffffff;
  --gray00a: rgba(255, 255, 255, 0);
  --gray02: #f6f6f6;
  --gray02a: rgba(0, 0, 0, 0.035);
  --gray03: #ebecec;
  --gray03a: rgba(0, 13, 13, 0.078);
  --gray05: #dddfdf;
  --gray05a: rgba(0, 15, 15, 0.133);
  --gray10: #cacdcd;
  --gray10a: rgba(0, 14, 14, 0.208);
  --gray20: #b5b8b8;
  --gray20a: rgba(0, 10, 10, 0.29);
  --gray30: #9ea1a1;
  --gray30a: rgba(0, 8, 8, 0.38);
  --gray40: #898c8e;
  --gray40a: rgba(0, 6, 11, 0.463);
  --gray50: #76797c;
  --gray50a: rgba(0, 6, 11, 0.537);
  --gray60: #64686a;
  --gray60a: rgba(0, 7, 10, 0.608);
  --gray70: #545659;
  --gray70a: rgba(0, 3, 7, 0.671);
  --gray80: #434547;
  --gray80a: rgba(0, 3, 5, 0.737);
  --gray90: #333436;
  --gray90a: rgba(0, 1, 4, 0.8);
  --gray100: #202121;
  --gray100a: rgba(0, 1, 1, 0.875);
  --blue02: #f1f9fc;
  --blue02a: rgba(0, 146, 200, 0.055);
  --blue03: #dbf0f7;
  --blue03a: rgba(0, 149, 198, 0.141);
  --blue05: #b4e8f4;
  --blue05a: rgba(0, 177, 218, 0.294);
  --blue10: #84daed;
  --blue10a: rgba(0, 178, 218, 0.482);
  --blue20: #5bc5de;
  --blue20a: rgba(0, 165, 204, 0.643);
  --blue30: #39aecb;
  --blue30a: rgba(0, 151, 188, 0.776);
  --blue40: #1698b8;
  --blue40a: rgba(0, 142, 177, 0.914);
  --blue50: #0383a4;
  --blue50a: rgba(0, 130, 163, 0.988);
  --blue60: #066f90;
  --blue60a: rgba(0, 108, 141, 0.976);
  --blue70: #055c7f;
  --blue70a: rgba(0, 89, 124, 0.98);
  --blue80: #00496f;
  --blue80a: rgba(0, 73, 111, 1);
  --blue90: #00365d;
  --blue90a: rgba(0, 54, 93, 1);
  --green02: #f8f8ef;
  --green02a: rgba(143, 143, 0, 0.063);
  --green03: #eeefc9;
  --green03a: rgba(175, 179, 0, 0.212);
  --green05: #e0e594;
  --green05a: rgba(181, 193, 0, 0.42);
  --green10: #c6d64e;
  --green10a: rgba(173, 196, 0, 0.694);
  --green20: #a7c41a;
  --green20a: rgba(157, 189, 0, 0.898);
  --green30: #83af1d;
  --green30a: rgba(115, 165, 0, 0.886);
  --green40: #679a1e;
  --green40a: rgba(83, 141, 0, 0.882);
  --green50: #4e871c;
  --green50a: rgba(56, 120, 0, 0.89);
  --green60: #367419;
  --green60a: rgba(32, 101, 0, 0.902);
  --green70: #206218;
  --green70a: rgba(9, 82, 0, 0.906);
  --green80: #0f511a;
  --green80a: rgba(0, 70, 12, 0.941);
  --green90: #023d18;
  --green90a: rgba(0, 59, 22, 0.992);
  --yellow02: #faf8ed;
  --yellow02a: rgba(184, 156, 0, 0.071);
  --yellow03: #faecb4;
  --yellow03a: rgba(238, 190, 0, 0.294);
  --yellow05: #fedd73;
  --yellow05a: rgba(253, 193, 0, 0.549);
  --yellow10: #f9c636;
  --yellow10a: rgba(247, 183, 0, 0.788);
  --yellow20: #f1ab0d;
  --yellow20a: rgba(240, 166, 0, 0.949);
  --yellow30: #e68c03;
  --yellow30a: rgba(230, 139, 0, 0.988);
  --yellow40: #d87000;
  --yellow40a: rgba(216, 112, 0, 1);
  --yellow50: #c85704;
  --yellow50a: rgba(199, 84, 0, 0.984);
  --yellow60: #b14402;
  --yellow60a: rgba(176, 67, 0, 0.992);
  --yellow70: #9a3301;
  --yellow70a: rgba(154, 50, 0, 0.996);
  --yellow80: #812401;
  --yellow80a: rgba(129, 35, 0, 0.996);
  --yellow90: #621c00;
  --yellow90a: rgba(98, 28, 0, 1);
  --red02: #fef6f4;
  --red02a: rgba(232, 46, 0, 0.043);
  --red03: #fee6e2;
  --red03a: rgba(246, 35, 0, 0.114);
  --red05: #fed6d6;
  --red05a: rgba(249, 0, 0, 0.161);
  --red10: #febbc4;
  --red10a: rgba(251, 0, 34, 0.267);
  --red20: #fd9cae;
  --red20a: rgba(250, 0, 46, 0.388);
  --red30: #f87895;
  --red30a: rgba(242, 0, 55, 0.529);
  --red40: #ec577f;
  --red40a: rgba(226, 0, 61, 0.659);
  --red50: #d6406e;
  --red50a: rgba(200, 0, 61, 0.749);
  --red60: #c0285c;
  --red60a: rgba(180, 0, 62, 0.843);
  --red70: #a90e4b;
  --red70a: rgba(164, 0, 65, 0.945);
  --red80: #8a0a3c;
  --red80a: rgba(133, 0, 52, 0.961);
  --red90: #6b062d;
  --red90a: rgba(103, 0, 40, 0.976);
  --purple02: #f9f4fe;
  --purple02a: rgba(116, 0, 232, 0.043);
  --purple03: #f3e9fa;
  --purple03a: rgba(116, 0, 197, 0.086);
  --purple05: #ead8fb;
  --purple05a: rgba(118, 0, 229, 0.153);
  --purple10: #dec3f6;
  --purple10a: rgba(115, 0, 217, 0.235);
  --purple20: #d0a8f3;
  --purple20a: rgba(117, 0, 220, 0.341);
  --purple30: #bf89f1;
  --purple30a: rgba(117, 0, 225, 0.463);
  --purple40: #af6eeb;
  --purple40a: rgba(114, 0, 220, 0.569);
  --purple50: #9e56db;
  --purple50a: rgba(109, 0, 201, 0.663);
  --purple60: #8c3fcc;
  --purple60a: rgba(102, 0, 187, 0.753);
  --purple70: #792cb6;
  --purple70a: rgba(93, 0, 167, 0.827);
  --purple80: #632296;
  --purple80a: rgba(75, 0, 134, 0.867);
  --purple90: #4d1577;
  --purple90a: rgba(61, 0, 107, 0.918);
  --danger02: #fef5ee;
  --danger02a: rgba(240, 105, 0, 0.067);
  --danger03: #fee7da;
  --danger03a: rgba(248, 90, 0, 0.145);
  --danger05: #fed7c8;
  --danger05a: rgba(250, 70, 0, 0.216);
  --danger10: #febfaa;
  --danger10a: rgba(252, 63, 0, 0.333);
  --danger20: #ff9f84;
  --danger20a: rgba(255, 56, 0, 0.482);
  --danger30: #fa7c61;
  --danger30a: rgba(247, 44, 0, 0.62);
  --danger40: #eb5e47;
  --danger40a: rgba(227, 32, 0, 0.722);
  --danger50: #da4234;
  --danger50a: rgba(209, 18, 0, 0.796);
  --danger60: #c32b26;
  --danger60a: rgba(184, 6, 0, 0.851);
  --danger70: #a9191d;
  --danger70a: rgba(160, 0, 4, 0.902);
  --danger80: #8a1317;
  --danger80a: rgba(129, 0, 4, 0.925);
  --danger90: #6b0c11;
  --danger90a: rgba(100, 0, 5, 0.953);
  --elev-veil-color: transparent;
  --gradient-color-base: 100%;

  color: var(--gray100);
  &:not([transparent]) {
    background: var(--gray00);
  }
`
